export default [
	{
		type: "object",
		name: "Has Property",
		cardinality: "single"
	}
]